import React, { useState, useRef } from 'react';
import Footer from '../components/footer';
import { createGlobalStyle } from 'styled-components';
import { isEmail } from "validator";
import AuthService from '../../services/auth.service';

const GlobalStyles = createGlobalStyle`
  header#myHeader.navbar.sticky.white {
    background: #403f83;
    border-bottom: solid 1px #403f83;
  }
  header#myHeader.navbar .search #quick_search{
    color: #fff;
    background: rgba(255, 255, 255, .1);
  }
  header#myHeader.navbar.white .btn, .navbar.white a, .navbar.sticky.white a{
    color: #fff;
  }
  header#myHeader .dropdown-toggle::after{
    color: rgba(255, 255, 255, .5);
  }
  header#myHeader .logo .d-block{
    display: none !important;
  }
  header#myHeader .logo .d-none{
    display: block !important;
  }
  @media only screen and (max-width: 1199px) {
    .navbar{
      background: #403f83;
    }
    .navbar .menu-line, .navbar .menu-line1, .navbar .menu-line2{
      background: #fff;
    }
    .item-dropdown .dropdown a{
      color: #fff !important;
    }
  }
`;

const required = (value) => {
  if (!value) {
    return (
      <div className="alert alert-danger" role="alert">
        This field is required!
      </div>
    );
  }
};

const validEmail = (value) => {
  if (!isEmail(value)) {
    return (
      <div className="alert alert-danger" role="alert">
        This is not a valid email.
      </div>
    );
  }
};

const vusername = (value) => {
  if (value.length < 3 || value.length > 20) {
    return (
      <div className="alert alert-danger" role="alert">
        The username must be between 3 and 20 characters.
      </div>
    );
  }
};

const vpassword = (value) => {
  if (value.length < 6 || value.length > 40) {
    return (
      <div className="alert alert-danger" role="alert">
        The password must be between 6 and 40 characters.
      </div>
    );
  }
};

const Register = () => {

  const form = useRef();
  const checkBtn = useRef();

  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [password, setPassword] = useState("");
  const [successful, setSuccessful] = useState(false);
  const [message, setMessage] = useState("");

  const onChangeUsername = (e) => {
    const username = e.target.value;
    setUsername(username);
  };

  const onChangeEmail = (e) => {
    const email = e.target.value;
    setEmail(email);
  };

  const onChangePassword = (e) => {
    const password = e.target.value;
    setPassword(password);
  };

  const handleRegister = (e) => {
    // e.preventDefault();

    setMessage("");
    setSuccessful(false);

    // form.current.validateAll();

    // if (checkBtn.current.context._errors.length === 0) {
    AuthService.register(username, email, password, phoneNumber).then(
      (response) => {
        setMessage(response.data.message);
        setSuccessful(true);
        setTimeout(() => {
          window.location.replace("/login");
        }, 2000);
        
      },
      (error) => {
        const resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        setMessage(resMessage);
        setSuccessful(false);
      }
    );
    // }
  };

  return (
    <div>
      <GlobalStyles />

      <section className='jumbotron breadcumb no-bg' style={{ backgroundImage: `url(${'./img/background/subheader.jpg'})` }}>
        <div className='mainbreadcumb'>
          <div className='container'>
            <div className='row'>
              <div className="col-md-12 text-center">
                <h1>Register</h1>
                <p>Anim pariatur cliche reprehenderit</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className='container'>
        <div className="row">

          <div className="col-md-8 offset-md-2">
            <h3>Don't have an account? Register now.</h3>
            <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.</p>

            <div className="spacer-10"></div>

            <div name="contactForm" id='contact_form' className="form-border" >
            {message && (
                      <div className="form-group">
                        <div className="alert alert-warning" role="alert">
                          {message}
                        </div>
                      </div>
                    )}

              <div className="row">

                <div className="col-md-6">
                  <div className="field-set">
                    <label>Name:</label>
                    <input type='text' name='name' id='name' className="form-control" />
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="field-set">
                    <label>Email Address:</label>
                    <input type='text'
                      value={email}
                      onChange={onChangeEmail}
                      validations={[required, validEmail]}
                      name='email'
                      id='email'
                      className="form-control" />
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="field-set">
                    <label>Choose a Username:</label>
                    <input type='text'
                      name='username'
                      value={username}
                      onChange={onChangeUsername}
                      validations={[required, vusername]}
                      id='username'
                      className="form-control" />
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="field-set">
                    <label>Phone:</label>
                    <input type='number' value={phoneNumber} onChange={(e)=> {setPhoneNumber(e.target.value)}} name='phone' id='phone' className="form-control" />
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="field-set">
                    <label>Password:</label>
                    <input type='text'
                      value={password}
                      onChange={onChangePassword}
                      validations={[required, vpassword]}
                      name='password'
                      id='password'
                      className="form-control" />
                  </div>
                </div>
                {/* 
              <div className="col-md-6">
                <div className="field-set">
                  <label>Re-enter Password:</label>
                  <input type='text' name='re-password' id='re-password' className="form-control" />
                </div>
              </div> */}

                <div className="col-md-12">
                  <div id='submit' className="pull-left">
                    <button id='send_message' className="btn btn-main color-2"
                      onClick={() => { handleRegister() }}>
                      Regsiter
                    </button>
                  </div>

                  <div className="clearfix"></div>
                  
                </div>

              </div>
            </div>
          </div>

        </div>
      </section>

      <Footer />
    </div>

  );
}
export default Register;